import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IDiscountRule } from "@pbm/discount-rules/contracts/discount-rule";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useDiscountRule(id: number) {
  const { request } = usePbm2Url();
  return useQuery(`discountRule:${id}`, async () => {
    const { Rules_discountRule } = await request(
      gql`
        query ($id: ID!) {
          Rules_discountRule(id: $id) {
            id
            type
            monthlyLimit
            createdAt
            updatedAt
            effectiveSince
            effectiveUntil
            accountedProducts {
              ean
              name
              package
            }
            discountedProducts {
              ean
              name
              package
            }
            ranges {
              saleDiscountPercentage
              boxesFrom
              boxesTo
              daysBetweenSalesInterval
              daysWithoutSalesTolerance
            }
          }
        }
      `,
      { id }
    );
    return Rules_discountRule as IDiscountRule;
  });
}
